module.exports = __webpack_public_path__ + "img/LuckyLarryLobstermania2_DG.24d512c1.png";